import React, { useMemo } from 'react';
import { FaDollarSign } from 'react-icons/fa';
import { IoDocumentText, IoTimeOutline, IoSwapHorizontalOutline, IoCalendarOutline } from 'react-icons/io5';

import { StatisticCard } from '@/components/statisticCard';
import { QuoteStatus } from '../types';
import { QUOTE_STATUS_LABELS, QUOTE_STATUS_HEX_COLORS } from '../constants';

interface StatusCount {
  statuscode: number;
  'statuscode@OData.Community.Display.V1.FormattedValue': string;
  count: number;
  'count@OData.Community.Display.V1.FormattedValue': string;
}

interface QuoteStatsProps {
  loading?: boolean;
  statusCounts?: StatusCount[];
  totalCount?: number;
  totalValue?: number;
  followupCount?: number;
}

interface StatusConfig {
  statuscode: number;
  label: string;
  icon: React.ReactNode;
  color: string;
}

const ALL_STATUSES: StatusConfig[] = [
  {
    statuscode: QuoteStatus.CONVERTED,
    label: QUOTE_STATUS_LABELS[QuoteStatus.CONVERTED],
    icon: <IoSwapHorizontalOutline size={14} />,
    color: QUOTE_STATUS_HEX_COLORS[QuoteStatus.CONVERTED],
  },
  {
    statuscode: QuoteStatus.EXPIRED,
    label: QUOTE_STATUS_LABELS[QuoteStatus.EXPIRED],
    icon: <IoCalendarOutline size={14} />,
    color: QUOTE_STATUS_HEX_COLORS[QuoteStatus.EXPIRED],
  },
];

export const QuoteStats: React.FC<QuoteStatsProps> = ({ statusCounts, totalCount, totalValue, loading, followupCount }) => {
  const statusCountsMap = useMemo(() => {
    const map: Record<number, number> = {};
    statusCounts?.forEach((item) => {
      map[item.statuscode] = item.count;
    });
    return map;
  }, [statusCounts]);

  return (
    <div className="flex gap-4 overflow-x-auto">
      <StatisticCard
        title="Total Quotes"
        value={totalCount ?? 0}
        icon={<IoDocumentText size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[160px]"
        enableAnimation={!loading}
      />
      <StatisticCard
        title="Total Value"
        value={totalValue ?? 0}
        prefix="£"
        icon={<FaDollarSign size={14} />}
        iconBgColor="#8b1538"
        className="min-w-[220px]"
        enableAnimation={!loading}
        decimals={2}
      />
      <StatisticCard
        title="Follow Up"
        value={followupCount ?? 0}
        icon={<IoTimeOutline size={14} />}
        iconBgColor={QUOTE_STATUS_HEX_COLORS[QuoteStatus.FOLLOW_UP_NEEDED]}
        className="min-w-[160px]"
        enableAnimation={!loading}
      />
      {ALL_STATUSES.map((status) => (
        <StatisticCard
          key={status.statuscode}
          title={status.label}
          value={statusCountsMap[status.statuscode] ?? 0}
          icon={status.icon}
          iconBgColor={status.color}
          className="min-w-[160px]"
          enableAnimation={!loading}
        />
      ))}


    </div>
  );
};

export default QuoteStats;

